export default "data:video/mp2t;base64,LyogZXNsaW50LWRpc2FibGUgcHJldHRpZXIvcHJldHRpZXIgKi8KZGVjbGFyZSBtb2R1bGUgJ0B0YXdrLnRvL3Rhd2stbWVzc2VuZ2VyLXJlYWN0Jzs="